import { t } from '../i18n';
import type { TileConfig } from '../config/schema';

interface TileCTAProps {
  tile: TileConfig;
  onOrder?: () => void;
}

export default function TileCTA({ tile, onOrder }: TileCTAProps) {
  if (tile.action === 'launch') {
    return (
      <a
        href={tile.href ?? '#'}
        target="_blank"
        rel="noopener noreferrer"
        className="dp-btn dp-btn--secondary"
        style={{ width: '100%', justifyContent: 'center' }}
        onClick={(e) => e.stopPropagation()}
      >
        {t('tile.cta.launch')}
        <span aria-hidden="true" style={{ marginLeft: 'var(--sp-1)' }}>↗</span>
      </a>
    );
  }
  if (tile.action === 'order') {
    return (
      <button
        className="dp-btn dp-btn--primary"
        style={{ width: '100%', justifyContent: 'center' }}
        onClick={(e) => { e.stopPropagation(); onOrder?.(); }}
      >
        {t('tile.cta.order')}
      </button>
    );
  }
  return (
    <button
      className="dp-btn dp-btn--ghost"
      style={{ width: '100%', justifyContent: 'center' }}
      onClick={(e) => e.stopPropagation()}
    >
      {t('tile.cta.manage')}
    </button>
  );
}
